import axios from 'axios';
import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import carImage from '../../images/Technician-login/bglogo.png';
import Loading from '../../loading';

const SignupTechnicianPage = () => {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate inputs
    if (!firstname || !lastname || !email || !password) {
      alert('Please fill in all required fields.');
      return;
    }
  
    // Check password strength
    const passwordPattern =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;  
    if (!passwordPattern.test(password)) {
      alert(
        "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character."
      );
      return;
    }
  
    // Create JSON payload
    const payload = {
      firstname,
      lastname,
      email,
      phoneNumber,
      password,
    };

    setLoading(true);
  
    try {
      await axios.post(`${API_URL}/api/auth/signup/technician`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      navigate('/login/technician');
    } catch (err) {
      console.error(err);
  
      // Display more detailed error messages if available
      const errorMessage =
        err.response?.data?.msg || 'Signup failed. Please try again.';
      alert(errorMessage);
    } finally {
      setLoading(false); // Stop loading after the try/catch
    }
  };  

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    
    // Check if the file is a PDF or an image
    if (selectedFile && !['application/pdf', 'image/jpeg', 'image/png'].includes(selectedFile.type)) {
      alert('Only PDF or image files are allowed.');
      return;
    }
    
    setFile(selectedFile);
  };

  return (
    <div className="flex relative justify-center bg-banner items-center h-screen font-clash">
      <form
        onSubmit={handleSubmit}
        className="relative z-10 p-8 lg:max-w-lg max-w-sm w-full shadow-lg rounded-2xl border border-[#F0FFC5] flex flex-col justify-center items-center sm:items-stretch bg-opacity-90 backdrop-filter backdrop-blur"
      >
        <div className="mb-4">
          <label className="block mb-2 text-[#F0FFC5]" htmlFor="firstname">
            Firstname
          </label>
          <input
            type="text"
            id="firstname"
            className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2 text-[#F0FFC5]" htmlFor="lastname">
            Lastname
          </label>
          <input
            type="text"
            id="lastname"
            className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-2 text-[#F0FFC5]" htmlFor="email">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
        <label className="block mb-2 text-[#F0FFC5]" htmlFor="phoneNumber">
          Phone Number (WhatsApp Number)
        </label>
        <input
          type="text"
          id="phoneNumber"
          className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
          value={phoneNumber}
          onChange={(e) => {
            const input = e.target.value;
            // Regex for Indian phone number (10 digits, starts with 6-9)
            if (/^[6-9][0-9]{0,9}$/.test(input) || input === "") {
              setPhoneNumber(input);
            }
          }}
          maxLength={10} // Ensures the input doesn't exceed 10 characters
          required
        />
      </div>
        <div className="mb-4 relative">
          <label className="block mb-2 text-[#F0FFC5]" htmlFor="password">
            Password
          </label>
          <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <div
            className="absolute right-3 top-11 text-[#F0FFC5] cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <AiOutlineEyeInvisible size={24} /> : <AiOutlineEye size={24} />}
          </div>
        </div>
        {loading ? (
        <div>
          <Loading />
        </div>
        ) : (
        <button
          type="submit"
          className="bg-transparent border border-[#F0FFC5] text-[#F0FFC5] font-bold mt-6 py-2 px-6 rounded-3xl w-full sm:w-auto hover:bg-[#F0FFC5] hover:text-black active:bg-[#D0FF93] active:text-black transition duration-300"
          disabled={loading}
        >
        Sign Up as Technician
        </button>
        )}
        </form>
      <img
        src={carImage}
        alt="car image"
        className="absolute bottom-0 w-full h-auto max-h-[400px] object-contain z-0 pointer-events-none"
      />
    </div>
  );
};

export default SignupTechnicianPage;
